import { useCubeContext } from 'Cube/communication/internal/cube.domain.context'

export const useEmbeddedSigningFlow = (): { isEnabled: boolean } => {
  const ctx = useCubeContext()

  const signatureMode = ctx.queries.rawData.data.quote.signatureMode

  /**
   * When `signatureMode` is defined (when quote is not DRAFT) the embedded flow UI is shown unless the quote
   * explicitly opts out via `NON_EMBEDDED`. When it isn't defined the embedded flow is enabled by default.
   */
  return {
    isEnabled: signatureMode !== 'NON_EMBEDDED'
  }
}
